import { Directive, HostListener, output } from '@angular/core';

@Directive({
  selector: '[ziroFileUploader]',
  standalone: false,
})
export class FileUploaderDirective {
  readonly fileDropped = output<FileList>();
  readonly fileOver = output<boolean>();

  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver.emit(true);
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver.emit(false);
  }

  @HostListener('drop', ['$event']) onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver.emit(false);
    const files = event.dataTransfer.files;
    if (files?.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
